module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_vm._v("LIBERATORIA")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questo libro propone un programma di raccomandazioni per esercizi.  Tuttavia, tutti i lettori devono consultare un medico qualificato prima di iniziare questo o qualsiasi altro programma salutare e di allenamento.  Come con qualsiasi programma di esercizio, se in qualsiasi momento si verifica qualsiasi disagio, dolore o coercizione di qualsiasi tipo, interrompere immediatamente e consultare il medico. Questo libro è pensato per un pubblico che è privo di qualsiasi regime di salute, limitazione fisica o lesione. I  creatori, i produttori, i partecipanti, gli inserzionisti ed i distributori di questo programma declinano qualsiasi passività o perdite in relazione gli esercizi o consigli che troverete qui. Qualsiasi attrezzatura o area di allenamento che viene utilizzato dovrebbe essere ispezionato accuratamente prima dell’uso per verificare che non ci siano pericoli, difetti o che sia compromesso.  L'utente si assume ogni responsabilità durante l'esecuzione di eventuali movimenti contenuti in questo libro e solleva il produttore di attrezzature, i produttori e i distributori di apparecchiature di tutte le passività.")]), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }), _c('div', {
    staticClass: "poetry"
  }), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold",
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_vm._v("Sommario")]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c003#_gjdgxs"
    }
  }, [_vm._v("Introduzione")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c003#_30j0zll"
    }
  }, [_vm._v("Linee Guida Generali di Cardio")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_1fob9te",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Le Quattro Routine con il Tapis Roulant per Cambiare")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_3znysh7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 1.1: Tapis Roulant per Cambiare")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_2et92p0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 1.2: Tapis Roulant per Cambiare")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_tyjcwt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 1.3: Tapis Roulant per Cambiare")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_3dy6vkm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 1.4: Tapis Roulant per Cambiare")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_4d34og8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Le Quattro Routine Ellittiche Frustanti")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_1t3h5sf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 2.1: Ellittica Frustante")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_2s8eyo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 2.2: Ellittica Frustante")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_17dp8vu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 2.3: Ellittica Frustante")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_3rdcrjn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 2.4: Ellittica Frustante")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_lnxbz9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Le Quattro Routine di Rottura")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_26in1rg",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 3.1: Rottura")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_35nkun2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 3.2: Rottura")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_1ksv4uv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parte 3.3: Rottura")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_44sinio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusione")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_2jxsxqh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grazie")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "none"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c004#_z337ya",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circa l’Autore")])]), _vm._v(" "), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I Miei Ulteriori Lavori")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_gjdgxs"
    }
  })]), _c('a', {
    attrs: {
      "id": "_gjdgxs"
    }
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Introduzione")])])]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_gjdgxs"
    }
  }, [_vm._v("Benjamin Franklin una volta disse che \"in questo mondo niente può essere certo, eccetto la morte e le tasse\".")]), _c('a', {
    attrs: {
      "id": "_ftnref1"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('sup', [_vm._v("[1]")])]), _vm._v(" Ancora, con ironia, con tutto il cuore non sono d'accordo ed aggiungo una terza eccezione nell'allenamento cardio respiratorio o meglio conosciuto come cardio. Dopo tutto, la maggior parte delle persone che vogliono essere in forma provano qualcosa che è già stato fatto prima di loro.  Corsa, camminata sportiva, ciclismo, salire le scale ed altre attività sono le cose che le persone utilizzano per fare il loro cardio. Ma, perché stanno facendo cardio esattamente?")])]), _c('a', {
    attrs: {
      "id": "_ftnref1"
    }
  }), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_ftnref1"
    }
  }, [_vm._v("All'inizio del 2015, l'Organizzazione Mondiale della Sanità (O.M.S.) ha dichiarato che più di 1.9 miliardi di adulti sono in sovrappeso e 600 milioni sono obesi. L'O.M.S. ha riportato che nel 2014, un barcollante 39% degli adulti erano in sovrappeso e il 13% erano obesi.")]), _c('a', {
    attrs: {
      "id": "_ftnref2"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('sup', [_vm._v("[2]")])]), _vm._v(" Quindi, non c'è da sorprendersi che una parte in sovrappeso della popolazione cerchi eventualmente una soluzione per alleviare il suo peso eccessivo. E, in alcuni casi, il loro medico di famiglia possa vagamente suggerire esercizio o cardio. Bene, da dove iniziano? E, devono inserire delle ore estenuanti in palestra?")])]), _c('a', {
    attrs: {
      "id": "_ftnref2"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A mio parere, l’allenamento cardio-respiratorio non dovrebbe essere opzionale in un allenamento fitness, dovrebbe essere obbligatorio. Tralasciando quest’area della salute e del fitness è come evitare le cure odontoiatriche.  I denti sono importanti nel mangiare e per avere una corretta digestione. Quindi, perdere i denti ostacola il mangiare e la digestione. Ecco perché lavarsi i denti, l’uso del filo interdentale, e il lavaggio della bocca esistono— per proteggere la vostra salute. E, questo è il parallelo tra l’igiene orale e il cardio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In parole povere, il cardio serve a rafforzare e sviluppare la resistenza nel sistema cardio-respiratorio, congiuntamente al cuore e ai polmoni. Il cuore è un muscolo e come qualsiasi altro muscolo del corpo, merita del tempo, attenzione e un’esercitazione diligente nel vostro programma di perdita di peso. Quando alleni il tuo cuore, guadagni vigore, resistenza, ed energia. L’allenamento cardio rende le attività di vita quotidiana più facili, dai tuoi allenamenti fino al compito più banale. E, la parte migliore è che il cardio è adatto per la maggior delle persone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Se la noia è la tua scusa per evitare l’allenamento cardio in palestra, io ho la soluzione. Io sono un po' diverso dagli altri personal trainer e mi appoggio un po' di più sulle alternative con un impatto inferiore a causa della mia esperienza di lavoro con clienti in sovrappeso, anziani e persone con bisogni speciali. Questi tipi di clienti necessitano di disporre di qualcosa che sarà efficace, ma anche sicura per le loro articolazioni, così ho concepito questi programmi per soddisfare più persone possibili.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Anche se ho sviluppato un programma cardio a basso impatto, come al solito, si prega di consultare il tuo medico di famiglia per l'approvazione preventiva. Queste routine potrebbero NON essere appropriate per te e anche se abbiamo avuto una consulenza di allenamento faccia a faccia, richiedo questo prima della tua partenza.")])]), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_ftnref2"
    }
  }, [_vm._v("La prima cosa che noterai è l'uso di intervalli durante ciascuno di questi programmi. Sono finiti i giorni in cui arrancavi per mantenere lo stesso ritmo durante tutti i minuti.  È stato dimostrato ripetutamente che in un allenamento ad alta intensità con intervalli brucia o più calorie e si allena meglio il cuore rispetto alle sessioni tradizionali di cardio che richiedono uno sforzo prolungato medio-basso o intensità.")]), _c('a', {
    attrs: {
      "id": "_ftnref3"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('sup', [_vm._v("[3]")])])])]), _c('a', {
    attrs: {
      "id": "_ftnref3"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il libro è diviso in tre tipi di strumenti— tapis roulant, ellittica e recumbent cyclette. Non tutte le attrezzature cardio sono la stessa cosa, quindi potrebbe essere necessario che tu regoli i livelli per te in modo da far combaciare l’attrezzatura che stai utilizzando.  Alcuni programmi possono trasferirsi ad altre apparecchiature cardio. Ad esempio, è possibile sostituire un recumbent cyclette per una cyclette verticale. In alternativa, è possibile utilizzare la programmazione ellittica su diversi altri modelli. Utilizza il tuo miglior giudizio quando ti alleni.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I tuoi sforzi dovrebbero essere intensi con la respirazione profonda e avere poca capacità di parlare. Su una scala da 0-10, 0 nessuno sforzo e 10 sei completamente senza fiato, dovresti essere tra 6-8. La scala è interamente soggettiva, quindi non paragonare i tuoi sforzi con quelli di chiunque altro. Sii onesto e rivaluta continuamente il tuo lavoro con ogni esercizio e allenamento. Evita di esercitarti ad un'intensità di 10, perché questo potrebbe essere dannoso per la tua salute e non dovresti mai spingerti fino a quando non riesci a respirare correttamente. Ai livelli più bassi di intensità, goditi il riposo e il recupero prima di saltare alla prossima raffica intensa. Il riposo è tanto importante quanto gli sforzi più difficili.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La linea di fondo è che il concetto di intervalli mi permette di creare programmi di cardio che sono lontani rispetto alla maggior parte delle sessioni di cardio.  Smettila di preoccuparti dei grafici e delle tabelle che trovi nelle attrezzature. Butta via le routine pre-programmate folli che le aziende di attrezzature cardio ti forniscono.  Questo libro è il tuo biglietto d'oro per le routine di cardio meno noiose e di allenamenti cardio migliori. Ora, continua a leggere, dacci dentro e divertiti con il tuo cardio per un cambiamento!")]), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }), _c('div', {
    staticClass: "poetry"
  })]), _c('div', {
    staticClass: "poetry"
  }, [_c('a', {
    attrs: {
      "id": "_ftnref3"
    }
  }), _c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "x-large",
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_ftnref3"
    }
  }), _c('a', {
    attrs: {
      "id": "_30j0zll"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Linee Guida Generali di Cardio")])])]), _c('a', {
    attrs: {
      "id": "_30j0zll"
    }
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("(Questo contiene un Estratto da "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The 3 Keys to Greater Health & Happiness")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "_30j0zll"
    }
  }), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('a', {
    attrs: {
      "id": "_30j0zll"
    }
  }, [_vm._v("Se desideri ottenere il massimo dal tuo allenamento cardio o da un allenamento di resistenza, è fondamentale per te sapere dove si trova la frequenza cardiaca durante i tuoi sforzi. Tieni d'occhio su quanto la frequenza cardiaca si eleva con ogni aumento di livello o intensità sull'apparecchiatura. In conclusione, discuto di due diverse opzioni per il monitoraggio del battito cardiaco. La soluzione più economica per controllare le tue pulsazioni è sulla tua arteria radiale nel polso. Allenati a controllare la frequenza cardiaca prima di lavorare in modo da avere una solida conoscenza sul posizionamento corretto del dito. L’American Heart Association è una grande risorsa per il")]), _c('a', {
    attrs: {
      "href": "http://www.heart.org/HEARTORG/Conditions/More/MyHeartandStrokeNews/All-About-Heart-Rate-Pulse_UCM_438850_Article.jsp",
      "target": "_blank"
    }
  }, [_vm._v(" corretto controllo del battito")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Per chiunque con condizioni speciali, abbia bisogno di servizi per la salute o sta prendendo dei farmaci prescritti, deve consultare il medico sulla frequenza cardiaca più sicura per il suo allenamento cardio. In base alla complessità della tua situazione, hai bisogno di una frequenza cardiaca prescritta dal dottore che sia sicura ed efficace.  Con la pratica dell’allenamento fisico, il medico aggiusterà il livello di allenamento con il tempo e l'esercizio costante.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’allenamento cardio è considerato come un allenamento che allena il cuore al 50-85% della frequenza cardiaca massima (FCM) o battiti massimi al minuto. Tratterò l’importanza della percentuale della frequenza cardiaca massima poco più avanti. In primo luogo, è necessario che tu conosca la tua frequenza cardiaca massima per stare al sicuro. Un allenamento tra il 50-85% della frequenza cardiaca massima mette abbastanza stress sul tuo cuore per creare la forza e la resistenza mentre stai bruciando calorie. Non c'è bisogno di lavorare troppo duramente, perché questo può essere controproducente per i tuoi obiettivi e distruttivo per il tuo corpo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Harvard Men’s Health Watch ")]), _vm._v("ha pubblicato un recente studio condotto da scienziati del Colorado che hanno rivelato una formula che stima con attenzione la frequenza cardiaca massima:"), _c('a', {
    attrs: {
      "id": "_ftnref4"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('sup', [_vm._v("[4]")])])])]), _c('a', {
    attrs: {
      "id": "_ftnref4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0